import { ResourceStatusEnum } from '@/types/schema';

// Make sure to update here to - @/modules/corporate/modules/quiz/views/QuizEditor/graphql/fragments/QuizEditorCacheUpdater.graphql
export const getQuizEditorCacheKey = (quizId: string) => `${quizId}${ResourceStatusEnum.Draft}`;
